import React, { useState, useEffect, useRef } from "react";
//utils
import {
  ordersCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import { useHistory } from "react-router";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { date, dateTime } from "../../../utils/dateTime";
import currency from "../../../utils/currency";
//material
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import useStyle from "./style";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ButtonGroup from "@material-ui/core/ButtonGroup";

//image
import imageLanding from "../../../assets/images/landing-image-third.png";
//component
import TabPanel from "../../../components/TabPanel";
import useCountDownTimer from "../../../components/useCountDownTimer";
import DetailDialog from "./DetailDialog";
import Gap from "../../../components/Gap";
import EmptyOrder from "./EmptyOrder";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import { useMediaQuery, useTheme } from "@material-ui/core";

function Timer({ expiration_date }) {
  const theme = useTheme();

  const miniScreen = useMediaQuery(theme.breakpoints.down("960"));

  const { timerArray } = useCountDownTimer(expiration_date);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        color: "#FFF",
        marginBottom: "10px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "4px",
          paddingTop: "10px",
          paddingBottom: "5px",
          paddingLeft: "10px",
          paddingRight: "10px",
        }}
      >
        <Typography
          style={
            miniScreen
              ? { fontWeight: "bold", fontSize: "10px", color: "black" }
              : { fontWeight: "bold", fontSize: "15px", color: "black" }
          }
        >
          {timerArray[0] > 9 ? timerArray[0] : `0${timerArray[0]}`}
        </Typography>
      </div>
      <div
        style={{
          borderRadius: "4px",
          color: "black",
          paddingTop: "10px",
          paddingBottom: "5px",
          paddingLeft: "5px",
          paddingRight: "5px",
        }}
      >
        :
      </div>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "4px",
          paddingTop: "10px",
          paddingBottom: "5px",
          paddingLeft: "10px",
          paddingRight: "10px",
        }}
      >
        <Typography
          style={
            miniScreen
              ? { fontWeight: "bold", fontSize: "10px", color: "black" }
              : { fontWeight: "bold", fontSize: "15px", color: "black" }
          }
        >
          {timerArray[1]}
        </Typography>
      </div>
      <div
        style={{
          borderRadius: "4px",
          color: "black",
          paddingTop: "10px",
          paddingBottom: "5px",
          paddingLeft: "5px",
          paddingRight: "5px",
        }}
      >
        :
      </div>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "4px",
          paddingTop: "10px",
          paddingBottom: "5px",
          paddingLeft: "10px",
          paddingRight: "10px",
        }}
      >
        <Typography
          style={
            miniScreen
              ? { fontWeight: "bold", fontSize: "10px", color: "black" }
              : { fontWeight: "bold", fontSize: "15px", color: "black" }
          }
        >
          {timerArray[2]}
        </Typography>
      </div>
    </div>
  );
}

function BelumBayarItem({ order, phone }) {
  const classes = useStyle();
  const [suborders, setSuborders] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const callExpired = useRef(false);
  const [dialogBatal, setDialogBatal] = useState(false);
 
  useEffect(() => {
    async function fetchSuborders() {
      const suborders = await ordersCollection
        .doc(order.id)
        .collection("suborders")
        .where("order_info.owner_id", "==", order.order_info.owner_id)
        .get();

      setSuborders(
        suborders.docs.map((doc) => {
          return {
            id: doc.id,
            ...doc.data(),
          };
        })
      );
    }
    fetchSuborders();
  }, [order.id]);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (order.expiration_date <= Date.now() && !callExpired.current) {
      callExpired.current = true;

      async function callSetOrderToExpired() {
        try {
          const setOrderToExpired =
            firefunctions.httpsCallable("setOrderToExpired");

          await setOrderToExpired({ order_id: order.id });
        } catch (e) {
          console.log(e.message);
        }
      }
      callSetOrderToExpired();
    }
  }, [order.expiration_date, order.id]);

  const [dialog, setDialog] = useState({
    open: false,
    orderId: {},
  });

  const handleDetail = (e) => {
    setDialog({
      open: true,
      orderId: order.id,
    });
  };

  const cancelOrder = async () => {
    if (loading) {
      return null;
    }
    setLoading(true);

    try {
      const callCancalOrder = firefunctions.httpsCallable("cancelOrder");
      await callCancalOrder({ order_id: order.id });
      setDialogBatal(false);
    } catch (error) {
      console.log(error.message);
    }
    setLoading(false);
  };
  // console.log(order?.transaction_info?.provider);
  return (
    <>
      <Paper elevation={0} className={classes.wrapPaper}>
        <div onClick={handleDetail}>
          <div className={classes.wrapHeaderTitle}>
            <div>
              <Typography className={classes.liquidSecondList}>
                {date(order.created_at?.toDate?.())}
              </Typography>
            </div>
            <div className={classes.belumBayar}>
              <Brightness1Icon
                style={{ fontSize: "10px", color: "gray", marginRight: "5" }}
              />
              <Typography className={classes.liquidSecondList}>
                Belum Dibayar
              </Typography>
            </div>
          </div>
          <Divider />
          <div
            className={classes.wrapHeaderTitle}
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <div>
              <CopyToClipboard
                text={order?.kode_order}
                onCopy={() => {
                  enqueueSnackbar("Kode Order Berhasil Disalin", {
                    variant: "success",
                  });
                }}
              >
                <Typography variant="caption" display="block">
                  <b>{order?.kode_order}</b>
                </Typography>
              </CopyToClipboard>{" "}
            </div>
            <div className={classes.belumBayar}>
              <FileCopyOutlinedIcon
                color="primary"
                style={{ width: "15", height: "15" }}
              />
            </div>
          </div>
          <Divider />
          <div
            className={classes.wrapCountdown}
            style={{
              backgroundColor: "#d5e0fb",
            }}
          >
            <div className={classes.wrapImage}>
              <img
                className={classes.image}
                src={imageLanding}
                alt="img-landing"
              />
            </div>
            <div>
              <Timer
                expiration_date={order.expiration_date}
                order_id={order.id}
              />
              <Typography className={classes.liquidPrimary}>
                Selesaikan Pembayaran
              </Typography>
              <Typography className={classes.liquidBold}>
                {dateTime(order.expiration_date)}
              </Typography>
            </div>
          </div>
          <Divider />
          <div className={classes.wrapCountdown}>
            <div className={classes.wrapImage}>
              <img
                className={classes.image}
                src={suborders?.[0]?.products?.[0]?.variant?.thumbnail?.[0]}
                alt={suborders?.[0]?.products?.[0]?.products_name?.[0]}
              />
            </div>
            <div>
              <Typography className={classes.liquidPrimary}>
                Jumlah Pengiriman
              </Typography>
              <Typography className={classes.liquidBold}>
                {suborders.length} Alamat
              </Typography>
              <Typography className={classes.liquidPrimary}>
                Total Pembayaran
              </Typography>
              <Typography className={classes.liquidBold}>
                {currency(order.total_nilai_dp ? order.total_nilai_dp : order.total_pembayaran)}
              </Typography>
            </div>
          </div>
        </div>
        <Divider />
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <div style={{ padding: "10px" }}>
            <Typography className={classes.liquidSecond}>
              Selesaikan Pembayaran. Pesananmu Menunggu Dibayar
            </Typography>
          </div>
          <div style={{ padding: "10px" }}>
            <Button
              fullWidth
              variant="contained"
              size="small"
              color="primary"
              onClick={() => {
                if (order?.transaction_info?.provider === "moota") {
                  history.push(`/moota/${order.token}`);
                } else {
                  history.push(`/payment/${order.token}`, {
                    goBack: "/transaksi/transaksilist/sellerapp/tokorame",
                  });
                }
              }}
            >
              Bayar Sekarang
            </Button>
          </div>
          <div style={{ padding: "10px" }}>
            <Button
              onClick={() => setDialogBatal(true)}
              size="small"
              color="secondary"
            >
              BatalKan Pesananan
            </Button>
          </div>
        </div>
      </Paper>
      <Gap height={30} />
      <Dialog open={dialogBatal} onClose={() => setDialogBatal(false)}>
        <DialogContent>
          <DialogTitle>
            <Typography>Apakah Anda Yakin?</Typography>
          </DialogTitle>
        </DialogContent>
        <DialogActions>
          <ButtonGroup fullWidth variant="text">
            <Button
              onClick={() => setDialogBatal(false)}
              color="primary"
              disabled={loading}
            >
              Tidak
            </Button>
            <Button onClick={cancelOrder} color="secondary" disabled={loading}>
              Batalkan
            </Button>
          </ButtonGroup>
        </DialogActions>
      </Dialog>
      <DetailDialog
        open={dialog.open}
        orderId={dialog.orderId}
        handleClose={() => {
          setDialog({
            open: false,
            orderId: {},
          });
        }}
      />
    </>
  );
}

function BelumBayar({ value, modes }) {
  const { orders } = useData();
  const pendingOrders =
    orders
      ?.filter((order) => {
        return (
          modes === order.order_info?.location &&
          (order.status === "not-paid" || order.status === "pending")
        );
      })
      .sort((a, b) => {
        const m2 = b.created_at?.toMillis?.() ?? 0;
        const m1 = a.created_at?.toMillis?.() ?? 0;

        return m2 - m1;
      }) ?? [];
  return (
    <TabPanel
      style={{ backgroundColor: "#EFF1FE" }}
      value={value}
      index="not-paid"
    >
      <div>
        {pendingOrders && pendingOrders.length > 0 ? (
          pendingOrders.map((item) => {
            return <BelumBayarItem key={item?.id} order={item} />;
          })
        ) : (
          <EmptyOrder />
        )}
      </div>
    </TabPanel>
  );
}

export default BelumBayar;
